import { RestfulService } from '../rest/restful';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { Injectable } from '@angular/core';

@Injectable()
export class VoucherActivityService extends RestfulService<Models.VoucherActivity> {
  constructor(public restService: RestService) {
    super(Models.VoucherActivity);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('voucher-activitys');
  }
}
